module.exports = __webpack_public_path__ + "img/49.baea2c5c.jpg";